import React, { useContext } from "react";
import { Td, Tr } from "@chakra-ui/react";
import MenuForm from "components/Menu/MenuForm";
import { NavLink, useNavigate } from "react-router-dom";
import FormCrudCRUDContext from "context/FormCrudContex";

const TbodyFormExitTemporary = ({ data }) => {
  const { setDataToShow } = useContext(FormCrudCRUDContext);
  const navigate = useNavigate();



  return (
    <Tr>
      <Td className="text-center">
        <NavLink
          to={`/FormShowExit?ExitNumber=${data?.outputForm_id}`}
          className="ms-2"
        >
          <span className="formNumber">{data?.code_outputForm}</span>
        </NavLink>
      </Td>
      <Td className="text-center">{data?.item}</Td>
      <Td className="text-center">{data?.output_form_item_description}</Td>
      <Td className="text-center">{data?.reference}</Td>
      <Td className="text-center">{data?.code_subheading}</Td>
      <Td className="text-center">{data?.num_import_declaration}</Td>
      <Td className="text-center">{data?.origin_name_country}</Td>
      <Td className="text-center">{data?.purchase_name_country}</Td>
      <Td className="text-center">{data?.destiny_name_country}</Td>
      <Td className="text-center">{data?.flag_name_country}</Td>
      <Td className="text-end">{data?.quantity}</Td>
      <Td className="text-end">{data?.inventory_quantity_temporary}</Td>
      <Td className="text-center">

      </Td>
    </Tr>
  );
};

export default TbodyFormExitTemporary;
